import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ExpenseVouchersService } from '../../../services/expense-vouchers.service';

@Component({
  selector: 'app-view-expense-receipt',
  templateUrl: './view-expense-receipt.component.html',
  styleUrl: './view-expense-receipt.component.scss'
})
export class ViewExpenseReceiptComponent {

  expenseVouchersData: any;

  constructor(
    private route: ActivatedRoute,
    private _expenseVouchersService: ExpenseVouchersService
  ) { }

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    this.getExpenseVoucher(id);
  }

  getExpenseVoucher(id: string | null): void {
    if (id) {
      this._expenseVouchersService.getById(Number(id)).subscribe((data: any) => {
        this.expenseVouchersData = data.data;
      });
    }
  }

  isDownloadingPdf = false;

  downloadPdf(): void {
    if (this.isDownloadingPdf || !this.expenseVouchersData) return;

    this.isDownloadingPdf = true;
    this._expenseVouchersService.downloadPdf(this.expenseVouchersData.id).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `ComprobanteEgreso_${this.expenseVouchersData.id}.pdf`;
        link.click();
        window.URL.revokeObjectURL(url);
        this.isDownloadingPdf = false;
      },
      error: (error) => {
        console.error('Error downloading PDF:', error);
        this.isDownloadingPdf = false;
        // Aquí podrías agregar una notificación de error
      }
    });
  }
}